import styled from 'styled-components'
import { Text } from 'pcln-design-system'

const EmailBanner = styled(Text)`
  @media (min-width: 600px) and (max-width: 1340px) {
    width: auto;
    display: inline-block !important;
  }

  @media (min-width: 0px) and (max-width: 600px) {
    display: none !important;
  }
`

EmailBanner.displayName = 'EmailBanner'

export default EmailBanner
